import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

export function Marquee() {
  const { dict } = useI18n();
  const items = dict.marquee.items;
  const doubled = [...items, ...items];

  return (
    <section aria-hidden="true" className="relative py-10 lg:py-14 border-y border-slate-800/70 bg-[#0F172A] overflow-hidden" data-testid="marquee-section">
      <div className="zmarquee-track">
        {doubled.map((label, i) => (
          <span key={i} className="flex items-center gap-8 pr-8 shrink-0">
            <span className="font-display text-3xl sm:text-4xl lg:text-6xl font-light tracking-tight text-slate-300/70 italic">
              {label}
            </span>
            <span className="w-2 h-2 rounded-full bg-emerald-500/70 shrink-0" />
          </span>
        ))}
      </div>
    </section>
  );
}

export default Marquee;
